import { useAuth } from '@auth/use-auth'
import { PageFallback } from '@components/page-fallback'
import { Navigate, useLocation } from 'react-router-dom'

export const SmartRedirect = ({ isInIframe }) => {
  const location = useLocation()
  const { initialized, userName, loading } = useAuth()
  console.log('smart redirect')

  if (!initialized || loading) {
    return <PageFallback />
  }

  if (isInIframe) {
    return userName ? (
      <Navigate replace to="/ask-ai" />
    ) : (
      <Navigate replace to="/not-available" state={{ from: location }} />
    )
  }

  return <Navigate replace to="/" />
}
